import { toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de043b34"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "jr-relative" }
const _hoisted_3 = ["id"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line jr-w-5 jr-h-3 jr-bg-gray-medium jr-rounded-full jr-shadow-inner jr-mr-1" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot jr-absolute jr-w-4 jr-h-4 jr-bg-gray jr-rounded-full jr-shadow jr--left-1.5 jr--top-0.5 jr-transition" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    for: _ctx.id,
    class: "jr-flex jr-items-center jr-cursor-pointer jr-bg-white jr-py-1.5 jr-px-2.5 jr-rounded-lg"
  }, [
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["label jr-mr-3 jr-font-medium jr-text-xs", { 'jr-text-primary': _ctx.value }])
    }, _toDisplayString(_ctx.label), 3), [
      [_vShow, _ctx.label]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        id: _ctx.id,
        type: "checkbox",
        class: "jr-sr-only",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args)))
      }, null, 40, _hoisted_3), [
        [_vModelCheckbox, _ctx.value]
      ]),
      _hoisted_4,
      _hoisted_5
    ])
  ], 8, _hoisted_1))
}